// extracted by mini-css-extract-plugin
export default {"subjectsView":"subjects-view_subjectsView__JuePh","notEditable":"subjects-view_notEditable__y8VC0"};